import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

const FeatureCard = ({ icon, title, description, premium }) => (
  <Card className={`bg-white border-gray-200 hover:border-[#00a3e0]/50 hover:shadow-md transition-all ${premium ? 'border-[#ffdd00]/30' : ''}`}>
    <CardContent className="pt-6">
      <div className={`w-12 h-12 rounded-md flex items-center justify-center mb-4 ${premium ? 'bg-[#ffdd00]/10 text-[#071734]' : 'bg-[#00a3e0]/10 text-[#00a3e0]'}`}>
        {icon}
      </div>
      <div className="flex items-center gap-2 mb-2">
        <h3 className="font-heading font-semibold text-lg text-[#071734]">{title}</h3>
        {premium && <Badge className="bg-[#ffdd00]/20 text-[#071734] border-[#ffdd00]/30">Pro</Badge>}
      </div>
      <p className="text-gray-600 text-sm">{description}</p>
    </CardContent>
  </Card>
);

export default FeatureCard;
